import PictureSubtraction from "../../components/UKG/Mathematics/SubstractionPicture";
import SubtractionVisual from "../../components/UKG/Mathematics/SubstractionVisual";
import SubstractionWordProblem from "../../components/UKG/Mathematics/SubstractionWordProblem";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

document.title = "Mamas Guidance - UKG - Mathematics - Substraction";

const topics: MenuItem[] = [
    { url: "/ukg/mathematics/substraction/picture-substraction", title: "Picture Substraction", component: PictureSubtraction},
    { url: "/ukg/mathematics/substraction/visual-substraction", title: "Visual Problem", component: SubtractionVisual},
    { url: "/ukg/mathematics/substraction/word-problem", title: "Word Problem", component: SubstractionWordProblem},
];


export default topics;